import PropTypes from 'prop-types';

import ReactStars from 'react-rating-stars-component';
import LinearProgress from '@mui/material/LinearProgress';

import UserReview from './UserReview/UserReview';
import UsersReviews from './UsersReviews/UsersReviews';
import classes from './ReviewsCourse.module.css';

const ReviewsCourse = props => {
  return (
    <div className={classes.productLearnInfoSection}>
      {props.accessCourse && (
        <UserReview
          dataCourse={props.dataCourse}
          showWriteReviewHandler={props.showWriteReviewHandler}
          showWriteReview={props.showWriteReview}
        />
      )}
      {!props.showWriteReview && (
        <>
          <h2 className={classes.includesTitle}>
            Valoración de alumnos
          </h2>
          <>
            <ReactStars
              edit={false}
              count={5}
              isHalf={true}
              size={24}
              classNames={classes.avgStars}
              activeColor="#e6a817"
              emptyStarColor="#d6d6d6"
              value={
                props.courseReviews
                  ? props.courseReviews.averageStars
                  : 2
              }
            />
            <p className={classes.starRatingValueText}>
              {props.courseReviews.averageStars
                ? props.courseReviews.averageStars % 2 === 1
                  ? Math.trunc(props.courseReviews.averageStars)
                  : parseFloat(
                      props.courseReviews.averageStars
                    ).toFixed(1)
                : 0}{' '}
              de 5
            </p>
            {props.courseReviews.reviewsStars.map(reviewStar => (
              <div
                key={reviewStar.star}
                className={classes.avgBarContainer}
              >
                <p className={classes.starRatingText}>
                  {reviewStar.star} Estrellas
                </p>
                <LinearProgress
                  classes={{
                    barColorPrimary: classes.linearBarColorPrimary
                  }}
                  className={classes.progressBar}
                  variant="determinate"
                  value={reviewStar.value}
                />
                <p className={classes.percentText}>
                  {parseFloat(reviewStar.value).toFixed(0)}%
                </p>
              </div>
            ))}
          </>
          <UsersReviews reviewsList={props.courseReviews.list} />
        </>
      )}
    </div>
  );
};

ReviewsCourse.propTypes = {
  // eslint-disable-next-line react/require-default-props
  accessCourse: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  showWriteReviewHandler: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  showWriteReview: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  dataCourse: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  courseReviews: PropTypes.object
};

export default ReviewsCourse;
